import { createContext, useContext } from 'react';
export const RuntimeContext = createContext(undefined);
export function useRuntime() {
    return useContext(RuntimeContext);
}
